<template>
  <div>
    <a-breadcrumb class="breadcrumb" style="display: inline-block;">
      <a-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
        <router-link v-if="item.name != name && index != 1" :to="{ path: item.path === '' ? '/' : item.path }">{{
          item.meta.title
        }}</router-link>
        <span v-else>{{ item.meta.title }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
import AppModel from '@/store/modules/app';
export default {
  data() {
    return {
      name: '',
      breadList: [],
    };
  },
  mounted() {},
  created() {
    this.getBreadcrumb();
  },

  methods: {
    getBreadcrumb() {
      this.breadList = [];
      // this.breadList.push({ name: 'index', path: '/', meta: { title: '首页' } });

      this.name = this.$route.name;
      this.$route.matched
        .filter(o => o.meta && o.meta.hiddenBreadcrumb !== true)
        .forEach(item => {
          // item.name !== 'index' && this.breadList.push(item)
          this.breadList.push(item);
        });
    },
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  text-align: left;
  margin-bottom: 16px;
  /* background-color: white; */
}
</style>
